// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__37qpb","index":"styles_index__1E520"};